<template>
  <el-form-item :label="(hideLabel || noLabel)? null : computedLabel" :prop="prop" :error="error" :class="computedClass">
    <!-- ラベル -->
    <template slot="label">
      <slot name="label"></slot>
    </template>
    <!-- ラベル -->
    <slot name="before"></slot>
    <slot name="default">
      <app-form-input
        ref = "input"
        :type="type"
        :prop="prop"
        :placeholder="placeholder"
        :options="options"
        :readonly="readonly"
        :disabled="disabled"
        @app-event="onAppEvent"/>
      <div class="app-hint" v-if="computedHint">
        <i class="el-icon-info"></i>{{computedHint}}
      </div>
    </slot>
    <slot name="after"></slot>
  </el-form-item>
</template>

<style scoped>
.app-hint {
  line-height: 10px;
  font-size: 10px;
  padding-top: 2px;
  /* margin-bottom:-12px; */
  /* see element-variables.scss */
}
.app-hint i{
  margin-right: 8px;
}
/*
.is-error .app-hint {
  display: none;
}
*/
.el-form--inline .el-form-item {
  margin-right: 20px;
}
.app-form-composite-item .el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppFormItem extends AppComponent {
  // 上位のフォームコンポーネントで公開されたフォームデータを参照
  @Inject('_app_form') form;

  @Prop({ required: false, default: null })
  label;

  @Prop({ required: false, default: null })
  hint;

  @Prop({ required: true })
  prop;

  @Prop({ required: false, default: false })
  hideLabel;

  @Prop({ required: false, default: false })
  noLabel;

  // inputへ透過
  @Prop({ required: false })
  type;

  // inputへ透過
  @Prop({ required: false })
  placeholder;

  // inputへ透過
  @Prop({ required: false })
  disabled;

  // inputへ透過
  @Prop({ required: false })
  readonly;

  // inputへ透過
  @Prop({ required: false })
  options;

  // 次のフォーカス遷移先プロパティ名
  @Prop({ required: false })
  nextFocus;

  get computedClass () {
    if (this.noLabel) {
      return 'app-form-item-no-label';
    }
  }

  get error () {
    // エラーメッセージが配列の場合は先頭のメッセージを表示
    if ((this.form !== null) &&
      ('errors' in this.form) &&
      (this.form.errors) &&
      (this.prop in this.form.errors)) {
      const error = this.form.errors[this.prop];
      return (Array.isArray(error)) ? error[0] : error;
    } else {
      return null;
    }
  }

  get schema () {
    return this.form.schema;
  }

  // ラベル取得
  get computedLabel () {
    if (this.label !== null) {
      return this.label;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('label' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].label;
      } else {
        return null;
      }
    }
  }

  // Hint取得
  get computedHint () {
    if (this.hint !== null) {
      return this.hint;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('hint' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].hint;
      } else {
        return null;
      }
    }
  }

  // 親コンポーネントへの透過イベント
  onAppEvent (...args) {
    // エンターキーイベント
    // プロパティ名を付加してemitする
    if (args[0] === 'enterkey') {
      this.$emit('app-event', ...args, this.prop);
      return;
    }
    // 値変更イベント
    // プロパティ名を付加してemitする
    // ※プロパティ名は添え字4固定
    if (args[0] === 'change') {
      const emitArgs = [];
      args.forEach((value) => {
        emitArgs.push(value);
      })
      emitArgs[4] = this.prop;
      this.$emit('app-event', ...emitArgs);
      return;
    }
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppFormItem.vue